/**************************************************
 * Nombre:       Formulario_Programa
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, FlagOutlined, SchoolOutlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPRODUCTO} from "../../../Constantes";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoSelectPropId from "../../../Modulo_formularios/Componentes/IngresoSelectPropId";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";

const Formulario_Programa = ({...props}) => {
    const [escuelas, setEscuelas] = useState([]);
    const [categorias, setCategorias] = useState([]);

    useEffect(() => {

        obtenerCol('escuelas').then(data => {
            if (data.res) {
                setEscuelas(data.data);
            }
        })

        obtenerCol('categorias').then(data => {
            if (data.res) {
                setCategorias(data.data);
            }
        })
    }, [])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>**Imagen Principal de 370px por 400px (fondo transparente) de menos
                        de 300K de
                        peso</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} alto={40} ancho={37} {...props}  />
                </Grid>


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelectPropId nombre={'Categoria'}
                                         dato={'categoria'} {...props} Icono={FlagOutlined} opciones={categorias}
                                         datoId={'idCategoria'} propiedadId={'id'} propiedad={'nombre'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={2} nombre={'Nombre del programa'}
                                  dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Descripcion corta'}
                                  dato={'descripcion'} {...props}

                    />

                </Grid>

                <Grid container size={6}>
                    <IngresoFecha nombre={'Fecha Inicio'}
                                  dato={'fechaInicio'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero nombre={'Inversion'}
                                   dato={'valor'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoSelectPropId nombre={'Escuela a la que pertenece'}
                                         dato={'escuela'} {...props} Icono={SchoolOutlined} opciones={escuelas}
                                         datoId={'idEscuela'} propiedadId={'id'} propiedad={'nombre'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Programa